$(document).ready(function () {
  $('a[href^="#"]').on('click', function (event) {
    const href = $(this).attr('href');
    const $target = $(href);

    if ($target.length) {
      $('html, body').animate(
        { scrollTop: $target.offset().top },
        600
      );
    }
  });
});
